import { TriggerPayloadPopupConfiguration } from '@/models/enrolment-review/trigger-payload-popup-configuration';
import { Event } from './event';

export class TriggerPayloadPopupConfigurationSharedEvent extends Event<TriggerPayloadPopupConfiguration> {}
